import React from 'react'
import { Link } from 'react-router-dom'

export default function Card({post,index}) {
  return (
    <>
      <div key={index} className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="mb-10 group wow fadeInUp" data-wow-delay={`.${index + 1}s`}>
                <div className="rounded overflow-hidden mb-8">
                  <Link to={`/blog-details/${post.id}`}  state={{data:post}} className="block">
                    <img
                      src={`https://limoapi.dev-mn.xyz/${post.thumbnail}`}
                      alt="thumbail"
                      className="w-full transition group-hover:scale-125 group-hover:rotate-6 h-[250px] object-cover	"
                    />
                  </Link>
                </div>
                <div>
                  <span className="bg-primary rounded inline-block text-center py-1 px-4 text-xm leading-loose font-semibold text-white mb-5">
                  Date   {post.created_at.slice(0,10)}
                  </span>
                  <h3>
                    <Link
                      to={`/blog-details/${post.id}`}
                      state={{data:post}}
                      className="font-semibold text-xl sm:text-2xl lg:text-xl xl:text-2xl mb-4 inline-block text-dark hover:text-primary"
                    >
                      {post.name}
                    </Link>
                  </h3>
                  {/* <p className="text-base text-body-color">
                  <div dangerouslySetInnerHTML={{ __html: post.description.slice(0, 40) }} />
                  </p> */}
                </div>
              </div>
            </div>
    </>
  )
}
